import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TokenAuth, UserDTO } from 'src/dto/users/users-dto';
import { decryptToObject } from 'src/environments/environment';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.css']
})
export class AccessDeniedComponent {

  constructor(private router: Router){
  }

  onReturnButton(){
    const user: TokenAuth = JSON.parse(decryptToObject(localStorage.getItem('CurrentUser')));
    if(user == null){
      this.router.navigate(['/login']);
    }
    this.router.navigate(['/login']);
   /* switch (user.roles[0].code) {

      case 'ADMIN':
        this.router.navigate(['/pim']);
        break;

      case 'PIM':
        this.router.navigate(['/pim']);
        break;

      case 'DAM':
        this.router.navigate(['/dam']);
        break;

      case 'CATALOG':
        this.router.navigate(['/catalogues']);
        break;

      case 'MEDIA_MANAGER':
        this.router.navigate(['/dam']);
        break;

      case 'GLRY_VIEW':
        this.router.navigate(['/login']);
        break;

      default:
        this.router.navigate(['/login']);
        break;
    } */
  }
}
